var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('one-cms-dynamic-component',{attrs:{"html":_vm.html}})
}
var staticRenderFns = []

export { render, staticRenderFns }